/* eslint-disable max-len */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-shadow */
/* eslint-disable indent */
import './style.scss';

import { useCallback, useEffect, useMemo, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useMutation, useQuery } from 'react-query';
import { Link, useNavigate, useParams } from 'react-router-dom';

import { Button } from 'primereact/button';
import { Message } from 'primereact/message';

import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { Can } from 'components/Can';
import ErrorDialog from 'components/ErrorDialog';
import Loading from 'components/Loading';

import Members from 'features/Council/components/Detail/Members';
import ConfirmSubmit from 'features/Council/components/Detail/Review/ConfirmSubmit';
import SpecializeDetail from 'features/Council/components/Detail/Review/SpecializeDetail';
import SpecializeForm from 'features/Council/components/Detail/Review/SpecializeForm';
import OwnerExplanation from 'features/Council/components/OwnerExplanation';
import SendMailRemindAllMembersDialog from 'features/Council/components/SendRemindMembersDialog';

import {
  downloadCouncilMemberExcelFile,
  downloadFile,
  getAllCouncilTypes,
  getSpecializationCouncilOfProjectProposal,
} from 'apis/councils.api';
import { getAll as getAllOrganizations } from 'apis/organizations.api';
import {
  generalInfoForCouncil,
  getAllVersions,
  getReviseLogs,
  updateExplanationRequest,
} from 'apis/projectProposals.api';
import {
  downloadDetailFile as downloadSpecializeReview,
  getDetailFile as getSpecializeReview,
  submitDetailFile as submitSpecializeReview,
} from 'apis/specializeReviews.api';

import {
  COUNCIL_STATUS,
  COUNCIL_TYPE_CODE,
  institutionalSpecialistSetting,
  PROJECT_ROLES,
  PROJECT_TYPES,
  TEMPLATE,
  TIMEZONE_VN,
  TOAST,
} from 'constant';
import { toast } from 'layout';

import {
  formatFileName,
  getAcadamicLevelShortHand,
  getFilterMembersAreAllowedReview,
  getRoles,
  checkIsAllowedCRUDCouncil,
  formatDatetime,
  roundNumber,
  getNumberMembersPresentAndReviewed,
  autoDownloadFile,
} from 'utils/func';
import RichTextViewer from 'components/RichTextViewer';

export default function SpecializationCouncil() {
  // #region Data
  const roles = getRoles();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { projectProposalId } = useParams();

  const [isFormModalOpen, setIsFormModalOpen] = useState(false);
  const [isDetailModalOpen, setIsDetailModalOpen] = useState(false);
  const [isConfirmSubmitModalOpen, setIsConfirmSubmitModalOpen] = useState(false);
  const Url = window.location.href;
  const isReadOnly = Url.includes('projects-submit');

  const { data: councilTypesData } = useQuery(['councilTypes'], getAllCouncilTypes, {
    staleTime: 5000 * 60,
  });
  // eslint-disable-next-line no-unused-vars
  const councilType = useMemo(() => {
    if (councilTypesData?.data?.length > 0) {
      return (
        councilTypesData?.data?.find(
          (item) => item?.code === COUNCIL_TYPE_CODE.SPECIALIZATION_COUNCIL
        ) ?? null
      );
    }
    return null;
  }, [councilTypesData?.data, t]);

  const { data: allProjectProposalVersionsData } = useQuery(
    ['allProjectProposalVersions', projectProposalId],
    () => getAllVersions(projectProposalId)
  );
  const [originalVersion, prequalificationVersion, specializationVersion, latestVersion] =
    useMemo(() => {
      if (allProjectProposalVersionsData?.data?.length > 0) {
        return [
          allProjectProposalVersionsData?.data?.find((item) => item?.version === 1) ?? null,
          allProjectProposalVersionsData?.data?.find((item) => item?.version === 2) ?? null,
          allProjectProposalVersionsData?.data?.find((item) => item?.version === 3) ?? null,
          allProjectProposalVersionsData?.data?.reduce((a, b) =>
            a?.version > b?.version ? a : b
          ) ?? null,
        ];
      }
      return [];
    }, [allProjectProposalVersionsData]);

  const isCombineSpecializationAndFinance = useMemo(
    () => originalVersion?.template === TEMPLATE[1595],
    [originalVersion]
  );

  // General info of project proposal (section A)
  const { data: generalInfoProjectProposalData } = useQuery(
    ['GeneralInfoProjectProposal', prequalificationVersion?.id],
    () => generalInfoForCouncil(prequalificationVersion?.id),
    {
      staleTime: 1000 * 60 * 5,
      enabled: !!prequalificationVersion?.id,
    }
  );
  const generalInfoProjectProposal = useMemo(
    () => generalInfoProjectProposalData?.data,
    [generalInfoProjectProposalData]
  );

  const owner = useMemo(
    () =>
      generalInfoProjectProposal?.projectProposalContacts?.find(
        (item) => item?.projectRole?.code === PROJECT_ROLES.OWNER
      ) ?? {},
    [generalInfoProjectProposal]
  );
  // end General info of project proposal (section A)

  // LƯU Ý: Đề tài chưa clone phiên bản thầy Vũ bảo vẫn hiện thông tin đề tài
  // => Hiển thị thông tin phiên bản mới nhất
  const { data: generalInfoLatestVersionData } = useQuery(
    ['GeneralInfoLatestVersion', latestVersion?.id],
    () => generalInfoForCouncil(latestVersion?.id),
    {
      enabled: !!latestVersion?.id,
    }
  );
  const generalInfoLatestVersion = useMemo(
    () => generalInfoLatestVersionData?.data,
    [generalInfoLatestVersionData]
  );
  const ownerLatestVersion = useMemo(
    () =>
      generalInfoLatestVersion?.projectProposalContacts?.find(
        (item) => item?.projectRole?.code === PROJECT_ROLES.OWNER
      ) ?? {},
    [generalInfoLatestVersion]
  );

  // Council
  const {
    data: councilData,
    isLoading,
    refetch: refetchCouncil,
  } = useQuery(['specializationCouncil', projectProposalId], () =>
    getSpecializationCouncilOfProjectProposal({ projectProposalId })
  );

  const council = useMemo(() => councilData?.data || null, [councilData]);

  const [councilMemberId, setCouncilMemberId] = useState(null);

  const {
    refetch: refetchCouncilMemberExcelFile,
    isLoading: isLoadingCouncilMemberExcelFile,
    isFetching: isFetchingCouncilMemberExcelFile,
  } = useQuery(
    [
      'downloadCouncilMemberExcelFile',
      council?.id,
      specializationVersion?.id ?? prequalificationVersion?.id,
    ],
    () =>
      downloadCouncilMemberExcelFile(
        council?.id,
        specializationVersion?.id ?? prequalificationVersion?.id
      ),
    {
      enabled: false,
      onSuccess: (res) => {
        autoDownloadFile(res);
      },
      onError: () => {
        toast(TOAST.ERROR, t('projectProposal.review.exportExcelErrorTitle'));
      },
    }
  );

  // end Council

  // Review (to check whether the council member has reviewed or not)
  const { data: specializeReviewData, refetch: specializeRefetch } = useQuery(
    ['specializeReviews', councilMemberId, council?.id, projectProposalId],
    ({ queryKey: [, _councilMemberId, _councilId, _projectProposalId] }) =>
      getSpecializeReview(_councilMemberId, _councilId, _projectProposalId),
    { enabled: !!councilMemberId }
  );

  const isCreateMode = useMemo(() => !specializeReviewData?.data, [specializeReviewData]);
  // end Review

  // Organizations (to get organization name for every council member)
  const { data: rawOrganizations } = useQuery(['Organizations'], getAllOrganizations, {
    staleTime: 1000 * 60 * 5,
  });
  const organizations = useMemo(
    () =>
      rawOrganizations?.data.map((e) => ({
        ...e,
        name: t('lang') === 'vi' ? e?.name : e?.englishName,
      })) ?? [],
    [rawOrganizations, t]
  );
  // end Organizations

  const {
    handleSubmit: handleSubmitFeedback,
    control: feedbackControl,
    reset: resetFeedback,
    formState: {
      errors: feedbackErrors,
      dirtyFields: feedbackDirtyFields,
      isDirty: isFeedbackDirty,
      isValid: isFeedbackValid,
    },
  } = useForm({ mode: 'onChange' });

  const {
    data: explanationRequestsData,
    isLoading: isExplanationRequestsLoading,
    refetch: refetchExplanationRequests,
  } = useQuery(
    [
      'projectProposalReviseLogs',
      projectProposalId,
      council?.councilType?.code,
      'ALL_REQUEST_EXPLANATION_SPECIALIZATION',
    ],
    () =>
      getReviseLogs({
        projectProposalId,
        types: ['REQUEST_EXPLANATION_SPECIALIZATION'],
      }),
    { enabled: !!projectProposalId && !!council?.councilType?.code }
  );

  const explanationRequest = useMemo(() => {
    if (explanationRequestsData?.data?.length > 0) {
      return explanationRequestsData?.data[0];
    }
    return null;
  }, [explanationRequestsData]);

  const [isVisibleErrorDialog, setIsVisibleDialogError] = useState(false);
  const [isVisibleConfirmSendRemind, setIsVisibleConfirmSendRemind] = useState(false);
  const {
    mutate: mutateDownloadFile,
    error: errorResDownloadFile,
    isError: isErrorResDownloadFile,
  } = useMutation(downloadFile);

  const { mutate: mutateDownloadSpecializeReviewFile } = useMutation(downloadSpecializeReview);

  const {
    mutate: mutateUpdateExplanationRequest,
    isLoading: isUpdateExplanationRequestLoading,
    error: errorUpdateExplanationRequest,
    isError: isErrorUpdateExplanationRequest,
  } = useMutation(updateExplanationRequest);
  // #endregion

  // #region Events
  useEffect(() => {
    if (explanationRequest) {
      resetFeedback({
        feedback: explanationRequest?.feedback ?? null,
        isOpened: explanationRequest?.isOpened,
        isEditAllowed: explanationRequest?.isEditAllowed,
      });
    }
  }, [explanationRequest]);

  const onFeedbackSubmit = (data) => {
    const formData = new FormData();

    formData.append('projectProposalId', projectProposalId);
    formData.append('id', explanationRequest?.id);

    if (data?.feedback) {
      formData.append('feedback', data.feedback);
    }

    formData.append('isOpened', data?.isOpened ? 'true' : 'false');
    formData.append('isEditAllowed', data?.isEditAllowed ? 'true' : 'false');

    // thêm cái này để không mất các commentFileUrls cũ
    if (explanationRequest?.commentFileUrls?.length > 0) {
      formData.append('oldCommentFileUrls', JSON.stringify(explanationRequest?.commentFileUrls));
    }

    // if isSendMailAllowed = false => not send email request explanation
    // else: check some more conditions to send email request explanation
    formData.append('isSendMailAllowed', 'true');

    mutateUpdateExplanationRequest(formData, {
      onSuccess: () => {
        toast(
          TOAST.SUCCESS,
          data?.isOpened
            ? t('projectProposal.requestExplanation.requestUpdateSuccess')
            : t('projectProposal.requestExplanation.addFeedbackSuccess')
        );
        refetchExplanationRequests();
      },
      onError: () => {
        setIsVisibleDialogError(true);
      },
    });
  };

  const checkFeedbackValidation = () => {
    if (!isFeedbackValid) {
      toast(TOAST.ERROR, t('errorMessage.validationErrorMessage'));
    }
  };

  const sumScoreInputFormOfMember = (score) => {
    const sum =
      (score?.scoreImportance ?? 0) +
      (score?.scoreQuality ?? 0) +
      (score?.scoreProduct ?? 0) +
      (score?.scoreCapability ?? 0) +
      (score?.scoreSubCriteria ?? 0);

    return sum;
  };

  const sumScoreInputFormOfAllMember = (members) => {
    // Filter members who are allowed to review and are present
    const presentMembers = members?.filter((member) => {
      const isAllowedReview = member?.councilMemberRole?.isAllowedReview;
      const isPresent = member?.isPresent;
      return isAllowedReview && isPresent !== false;
    });

    return presentMembers?.reduce(
      (sum, member) =>
        sum +
        (sumScoreInputFormOfMember(member?.projectProposalCouncilMembers?.[0]?.specializeReview) ||
          member?.projectProposalCouncilMembers?.[0]?.review?.reviewValues?.evaluation
            ?.totalScore ||
          0),
      0
    );
  };

  const getNumberMembersReviewed = (members) => getNumberMembersPresentAndReviewed(members);

  const handleDownloadFile = (path, id) => {
    mutateDownloadFile(
      { path, id },
      {
        onSuccess: (res) => {
          if (res?.data) {
            const file = new Blob([res.data]);

            const link = document.createElement('a');
            link.href = URL.createObjectURL(file);
            link.download = formatFileName(path);

            link.click();
          }
        },
        onError: () => {},
      }
    );
  };

  const handleDownloadSpecializeReviewFile = (
    councilMemberId,
    projectProposalId,
    councilId,
    path
  ) => {
    mutateDownloadSpecializeReviewFile(
      { councilMemberId, projectProposalId, councilId, path },
      {
        onSuccess: async (res) => {
          if (res?.data) {
            const file = new Blob([res.data]);

            const link = document.createElement('a');
            link.href = URL.createObjectURL(file);
            link.download = formatFileName(path);

            link.click();
          }
        },
      }
    );
  };
  // #endregion

  const accept = useCallback(() => {
    navigate(
      `/projects-revise/${projectProposalId}/council/edit/${council?.id}/${
        council?.councilType?.id ?? councilType.id
      }?key=editResult`
    );
  }, [projectProposalId, council?.id, council?.councilType?.id ?? councilType?.id]);

  const confirmUpdateResult = useCallback(() => {
    confirmDialog({
      message: t('council.createCouncilNoMember.specialization'),
      header: t('council.createCouncilNoMember.confirmationTitle'),
      icon: 'pi pi-exclamation-triangle',
      defaultFocus: 'accept',
      style: { width: '25vw' },
      accept,
      acceptLabel: t('formLayout.action.ok'),
      rejectLabel: t('formLayout.action.cancel'),
      draggable: false,
    });
  }, [accept]);

  const renderCouncilName = () => {
    if (isLoading) return t('council.view.councilType.council');
    if (isCombineSpecializationAndFinance)
      return t('council.view.councilType.specializationAndFinanceCouncil').toUpperCase();
    return t('council.view.councilType.specializationCouncil').toUpperCase();
  };

  if (isLoading) return <Loading />;

  return (
    <>
      {isErrorResDownloadFile && (
        <ErrorDialog
          title={t('council.edit.titleEditCouncilError')}
          isError={isErrorResDownloadFile}
          error={errorResDownloadFile}
          visible={isVisibleErrorDialog}
          setVisible={setIsVisibleDialogError}
        />
      )}
      {isErrorUpdateExplanationRequest && (
        <ErrorDialog
          title={t('projectProposal.requestExplanation.errorRequestExplanationTitle')}
          isError={isErrorUpdateExplanationRequest}
          error={errorUpdateExplanationRequest}
          visible={isVisibleErrorDialog}
          setVisible={setIsVisibleDialogError}
        />
      )}
      <SendMailRemindAllMembersDialog
        visible={isVisibleConfirmSendRemind}
        setVisible={setIsVisibleConfirmSendRemind}
        refetch={refetchCouncil}
        council={{
          councilType: {
            code: COUNCIL_TYPE_CODE.SPECIALIZATION_COUNCIL,
          },
          ...(council ?? {}),
        }}
      />

      {(isExplanationRequestsLoading || isUpdateExplanationRequestLoading) && <Loading />}

      <div className="bg-white p-5">
        {!isReadOnly &&
          checkIsAllowedCRUDCouncil(generalInfoLatestVersionData?.data?.projectType, roles) && (
            <div className="flex justify-content-end align-items-center">
              <div className="flex gap-2">
                {((council && council?.councilMembers?.length > 0) || !council) && !isLoading && (
                  <>
                    <Can do="read_member" on="council">
                      <Button
                        icon="pi pi-download"
                        severity="success"
                        label={t('council.viewList.downloadCouncilMemberExcel')}
                        tooltipOptions={{ position: 'left' }}
                        onClick={() => {
                          refetchCouncilMemberExcelFile();
                        }}
                        disabled={
                          !council ||
                          council?.councilMembers?.length === 0 ||
                          isLoadingCouncilMemberExcelFile ||
                          isFetchingCouncilMemberExcelFile
                        }
                        loading={
                          isLoadingCouncilMemberExcelFile || isFetchingCouncilMemberExcelFile
                        }
                      />
                    </Can>
                    <Can do="send_mail" on="council">
                      <Button
                        icon="pi pi-envelope"
                        severity="success"
                        onClick={() => {
                          setIsVisibleConfirmSendRemind(true);
                        }}
                        tooltip={`${t('council.viewList.sendRemindMember')}
              ${t('council.fields.numberSentMail')}: ${
                          council?.projectProposalCouncils?.[0]?.numberSentMail ?? 0
                        }
              ${t('council.fields.lastSentMail')}: ${formatDatetime(
                          council?.projectProposalCouncils?.[0]?.lastSentMail,
                          'HH:mm:ss DD/MM/YYYY'
                        )}`}
                        tooltipOptions={{ position: 'left' }}
                        disabled={!council?.completedAt || council?.councilMembers?.length <= 0}
                      />
                    </Can>
                    <Can do="create" on="council">
                      {!council?.deletedAt && !council && (
                        <Link
                          to={`/projects-revise/${projectProposalId}/council/create/${councilType?.id}`}
                          className={`pointer-events-${
                            latestVersion?.version < 2 ? 'none' : 'auto'
                          }`}
                          state={{ isCombineSpecializationAndFinance }}
                        >
                          <Button
                            icon="pi pi-plus"
                            severity="primary"
                            tooltip={t('council.viewList.addCouncil')}
                            tooltipOptions={{ position: 'left' }}
                            disabled={latestVersion?.version < 2}
                          />
                        </Link>
                      )}
                    </Can>
                    <Can do="update" on="council">
                      {council && !council?.deletedAt && council?.isAllowedToEditCouncil && (
                        <Link
                          to={`/projects-revise/${projectProposalId}/council/edit/${council?.id}/${council?.councilType?.id}?key=editCouncil`}
                          onClick={(e) => {
                            if (
                              !checkIsAllowedCRUDCouncil(
                                generalInfoLatestVersion?.projectType,
                                roles
                              )
                            ) {
                              e.preventDefault();
                              toast(TOAST.ERROR, t('permission.forbid.edit.council'));
                            }
                          }}
                          state={{ isCombineSpecializationAndFinance }}
                        >
                          <Button
                            icon="pi pi-pencil"
                            severity="warning"
                            tooltip={t('council.viewList.editCouncil')}
                            tooltipOptions={{ position: 'left' }}
                          />
                        </Link>
                      )}
                    </Can>
                  </>
                )}
                <Can do="update" on="council">
                  <Link
                    to={`/projects-revise/${projectProposalId}/council/edit/${council?.id}/${
                      council?.councilType?.id ?? councilType.id
                    }?key=editResult`}
                    className={`pointer-events-${latestVersion?.version < 2 ? 'none' : 'auto'}`}
                    onClick={(e) => {
                      if (
                        !checkIsAllowedCRUDCouncil(generalInfoProjectProposal?.projectType, roles)
                      ) {
                        e.preventDefault();
                        toast(TOAST.ERROR, t('permission.forbid.create.council'));
                      }

                      if (!council && !council?.members) {
                        e.preventDefault();
                        confirmUpdateResult();
                      }
                    }}
                  >
                    <Button
                      icon="pi pi-check-square"
                      className="bg-teal-600 border-teal-600"
                      tooltip={t('council.viewList.editResult')}
                      tooltipOptions={{ position: 'left' }}
                      disabled={latestVersion?.version < 2}
                    />
                  </Link>
                </Can>
              </div>
            </div>
          )}

        <div className="m-0 bg-white p-5 p-fluid detail-info-council">
          <div className="flex flex-column mb-5">
            <h3
              className="line-height-3 text-4xl text-center font-semibold"
              style={{ marginBottom: '0px', paddingBottom: '1px' }}
            >
              {renderCouncilName()}
            </h3>

            {council && !council?.completedAt && !isReadOnly && (
              <h4 className="text-red-500 text-center">({t('council.view.notDoneAndSentMail')})</h4>
            )}
            {council &&
              council?.completedAt &&
              council?.councilMembers?.some((item) => !item?.isSentMail) && (
                <h4 className="text-blue-600 text-center">({t('council.view.onlyDone')})</h4>
              )}
          </div>

          <div className="ml-0 sm:ml-0 md:ml-4 lg:ml-4">
            <div className="pb-2">
              {/* Name and owner of project proposal */}
              <div className="text-lg mb-3">
                <h4 className="mb-3">{t('council.view.overviewLabel').toUpperCase()}</h4>
                <div className="ml-4 grid">
                  <div className="col-12">
                    <span className="font-semibold">
                      {t('projectProposal.general.projectNameAndType.vietnameseName')}:{' '}
                    </span>
                    <span>
                      {generalInfoProjectProposal?.vietnameseName ||
                        generalInfoLatestVersion?.vietnameseName}
                    </span>
                  </div>
                  <div className="col-12">
                    <span className="font-semibold">
                      {t('projectProposal.general.projectNameAndType.englishName')}:{' '}
                    </span>
                    <span>
                      {generalInfoProjectProposal?.englishName ||
                        generalInfoLatestVersion?.englishName}
                    </span>
                  </div>
                  <div className="col-12">
                    <span className="font-semibold">
                      {t('projectProposal.general.ownerSection.labelCouncil')}:{' '}
                    </span>
                    <span>
                      {owner?.fullname || generalInfoProjectProposal?.owner?.fullname
                        ? `${getAcadamicLevelShortHand(
                            owner?.academicRank,
                            owner?.academicDegree,
                            t,
                            true
                          )}${owner?.fullname ?? generalInfoProjectProposal?.owner?.fullname ?? ''}`
                        : `${getAcadamicLevelShortHand(
                            ownerLatestVersion?.academicRank,
                            ownerLatestVersion?.academicDegree,
                            t,
                            true
                          )}${
                            ownerLatestVersion?.fullname ??
                            generalInfoLatestVersion?.owner?.fullname ??
                            ''
                          }`}
                    </span>
                  </div>
                </div>
              </div>

              {/* Council info */}
              <div className="text-lg mb-3">
                <h4 className="mb-3">
                  {isCombineSpecializationAndFinance
                    ? t(
                        'council.view.councilInfoLabel.specializationAndFinanceCouncil'
                      ).toUpperCase()
                    : t('council.view.councilInfoLabel.specializationCouncil').toUpperCase()}
                </h4>
                <div className="ml-4 mb-2 grid">
                  <div className="col">
                    <span className="font-semibold">
                      {t('council.fields.name.specializationCouncil')}:{' '}
                    </span>
                    <span className="w-full">{council?.name}</span>
                  </div>
                </div>
                <div className="ml-4 grid">
                  <div className="col-12 sm:col-6 md:col-6 lg:col-6">
                    <span className="font-semibold">{t('council.fields.establishDate')}: </span>
                    <span>
                      {council?.timeCreated &&
                        new Date(council?.timeCreated).toLocaleDateString('en-GB', {
                          timeZone: TIMEZONE_VN,
                        })}
                    </span>
                  </div>
                  <div className="col-12 sm:col-6 md:col-6 lg:col-6">
                    <span className="font-semibold">
                      {t('council.fields.decisionToEstablish')}:{' '}
                    </span>
                    {council?.projectProposalCouncils?.[0]?.establishmentFileUrl && (
                      <span
                        className="p-link text-primary underline"
                        onClick={() =>
                          handleDownloadFile(
                            council.projectProposalCouncils[0].establishmentFileUrl,
                            council?.id
                          )
                        }
                      >
                        {t('council.view.decision')}
                      </span>
                    )}
                  </div>
                  <div className="col-12 sm:col-6 md:col-6 lg:col-6">
                    <span className="font-semibold">{t('council.fields.reviewDeadline')}: </span>
                    {council?.projectProposalCouncils?.[0]?.reviewDeadline &&
                      new Date(
                        council?.projectProposalCouncils?.[0]?.reviewDeadline
                      ).toLocaleDateString('en-GB', { timeZone: TIMEZONE_VN })}
                  </div>
                  <div className="col-12 sm:col-6 md:col-6 lg:col-6">
                    <span className="font-semibold">{t('council.fields.meetingDate')}: </span>
                    <span>
                      {council?.projectProposalCouncils?.[0]?.timeMet &&
                        new Date(council?.projectProposalCouncils?.[0]?.timeMet).toLocaleDateString(
                          'en-GB',
                          { timeZone: TIMEZONE_VN }
                        )}
                    </span>
                  </div>
                  <div className="col-12 sm:col-6 md:col-6 lg:col-6">
                    <span className="font-semibold">{t('council.fields.totalScore')}: </span>
                    <span>{council?.projectProposalCouncils?.[0]?.scoreTotal}</span>
                  </div>
                  <div className="col-12 sm:col-6 md:col-6 lg:col-6">
                    <span className="font-semibold">{t('council.fields.averageScore')}: </span>
                    <span>{roundNumber(council?.projectProposalCouncils?.[0]?.scoreAverage)}</span>
                  </div>
                  <div className="col-12 sm:col-6 md:col-6 lg:col-6">
                    <span className="font-semibold">{t('council.fields.classification')}: </span>
                    <span>{council?.projectProposalCouncils?.[0]?.classification}</span>
                  </div>
                  <div className="col-12 sm:col-6 md:col-6 lg:col-6">
                    <span className="font-semibold">{t('council.fields.result')}: </span>
                    <span>
                      {council?.projectProposalCouncils?.[0]?.councilStatus !==
                      COUNCIL_STATUS.QUALIFIED ? (
                        council?.projectProposalCouncils?.[0]?.councilStatus ===
                        COUNCIL_STATUS.NOT_QUALIFIED ? (
                          <span className="text-success">{t('council.viewList.notQualified')}</span>
                        ) : (
                          <span className="text-danger">{t('council.viewList.notReviewed')}</span>
                        )
                      ) : (
                        <span className="text-danger">{t('council.viewList.qualified')}</span>
                      )}
                    </span>
                  </div>
                  <Can do="read_member" on="council">
                    <div className="col-12 sm:col-6 md:col-6 lg:col-6">
                      <span className="font-semibold">
                        {t('council.fields.numberOfMembersReviewed')}:{' '}
                      </span>
                      <span>
                        {getNumberMembersReviewed(council?.councilMembers)}/
                        {getFilterMembersAreAllowedReview(council?.councilMembers)?.length}
                      </span>
                    </div>
                    <div className="col-12 sm:col-6 md:col-6 lg:col-6">
                      <span className="font-semibold">
                        {t('council.fields.currentTotalScoreReviewed')}:{' '}
                      </span>
                      <span>{sumScoreInputFormOfAllMember(council?.councilMembers)}</span>
                    </div>
                  </Can>
                </div>
                {/* Council members */}
                <Can do="read_member" on="council">
                  <div>
                    <h4 className="mb-3">{t('council.view.councilMemberLabel')}</h4>
                    <div className="ml-4">
                      {!isLoading && council?.councilMembers && (
                        <Members
                          refetch={refetchCouncil}
                          council={council}
                          members={council?.councilMembers}
                          councilType={council?.councilType}
                          organizations={organizations}
                          setIsFormModalOpen={setIsFormModalOpen}
                          setIsDetailModalOpen={setIsDetailModalOpen}
                          setCouncilMemberId={setCouncilMemberId}
                          projectProposalId={prequalificationVersion?.id}
                          councilId={council?.id}
                          reviewDeadline={council?.projectProposalCouncils?.[0]?.reviewDeadline}
                          isShowScore
                          isShowValidScore
                          isReadOnly={
                            isReadOnly ||
                            !checkIsAllowedCRUDCouncil(generalInfoLatestVersion?.projectType, roles)
                          }
                          yearProposed={
                            parseInt(generalInfoProjectProposal?.yearProposed, 10) || null
                          }
                          template={generalInfoProjectProposal?.template}
                          hasProjects={false}
                        />
                      )}
                    </div>
                  </div>
                </Can>

                {/* General conclusion */}
                <div>
                  <h4 className="mb-3">{t('council.view.conclusion.specializationCouncil')}</h4>
                  {council?.projectProposalCouncils?.[0]?.isApproved === false && (
                    <div className="ml-4">
                      <Message
                        severity="error"
                        text={t('council.view.refuse')}
                        className="w-max font-semibold"
                      />
                      <p className="mt-3">{t('council.view.reason')}</p>
                      <RichTextViewer
                        style={{ minHeight: '200px', width: '100%' }}
                        value={council?.projectProposalCouncils?.[0]?.conclusion}
                        showHeader={false}
                        readOnly
                      />
                    </div>
                  )}
                  {council?.projectProposalCouncils?.[0]?.isApproved === true && (
                    <div className="ml-4">
                      <Message
                        severity="success"
                        text={t('council.view.approve')}
                        className="w-max font-semibold"
                      />
                      <p className="mt-3">{t('council.view.opinion')}:</p>
                      <p className="font-italic mt-4">{t('council.view.opinionDetail')}</p>
                      <RichTextViewer
                        style={{ minHeight: '200px', width: '100%' }}
                        value={council?.projectProposalCouncils?.[0]?.conclusion}
                        showHeader={false}
                        readOnly
                      />
                    </div>
                  )}
                </div>
              </div>

              {/* Result minutes */}
              <div className="flex text-lg mt-2 flex-column">
                <h4 className="mb-3">
                  {t(
                    'council.view.appraisalCouncilMinutesLabel.specializationCouncil'
                  ).toUpperCase()}
                </h4>
                <div className="flex ml-5 flex-column">
                  <div className="mb-2">
                    {council?.projectProposalCouncils?.[0]?.reportFileUrl ? (
                      <span
                        className="p-link text-primary underline"
                        onClick={() =>
                          handleDownloadFile(
                            council?.projectProposalCouncils?.[0]?.reportFileUrl,
                            council?.id
                          )
                        }
                      >
                        {t('council.view.appraisalCouncilMinutes')}
                      </span>
                    ) : (
                      <span className="font-italic">
                        {t('council.view.noAppraisalCouncilMinutes')}
                      </span>
                    )}
                  </div>
                </div>
              </div>

              {/* Specialist's comment */}
              <div className="flex text-lg mt-2 flex-column">
                <h4 className="mb-3">
                  {t('projectProposal.requestExplanation.specialistComment')}
                </h4>
                <div className="flex ml-5 flex-column">
                  <div className="mb-2">
                    {explanationRequest?.comment && (
                      <p
                        className="font-italic text-justify m-0"
                        style={{ whiteSpace: 'pre-wrap' }}
                      >
                        {explanationRequest?.comment}
                      </p>
                    )}
                  </div>
                </div>
              </div>

              {/* Owner Explanation */}
              {checkIsAllowedCRUDCouncil(generalInfoLatestVersion?.projectType, roles, {
                institutionalSetting: [
                  ...institutionalSpecialistSetting,
                  ...(isCombineSpecializationAndFinance ? [PROJECT_TYPES.A, PROJECT_TYPES.B, PROJECT_TYPES.SCIENCE_AND_TECHNOLOGY_PROJECT] : []),
                ],
              }) && (
                <OwnerExplanation
                  control={feedbackControl}
                  errors={feedbackErrors}
                  isDirty={isFeedbackDirty}
                  dirtyFields={feedbackDirtyFields}
                  handleSubmit={handleSubmitFeedback(onFeedbackSubmit)}
                  checkValidation={checkFeedbackValidation}
                  handleDownloadFile={handleDownloadFile}
                  explanationRequest={explanationRequest}
                  correspondingVersion={specializationVersion}
                  council={council}
                  isReadOnly={isReadOnly}
                />
              )}
            </div>
          </div>
        </div>

        <ConfirmDialog />

        {councilMemberId && (
          <>
            <SpecializeForm
              visible={isFormModalOpen}
              setVisible={setIsFormModalOpen}
              isCreateMode={isCreateMode}
              councilMemberId={councilMemberId}
              councilId={council?.id}
              projectProposalId={projectProposalId}
              handleDownloadReviewFile={handleDownloadSpecializeReviewFile}
              setIsConfirmSubmitModalOpen={setIsConfirmSubmitModalOpen}
              refetchSpecialize={specializeRefetch}
              refetchCouncil={refetchCouncil}
            />
            <SpecializeDetail
              visible={isDetailModalOpen}
              setVisible={setIsDetailModalOpen}
              councilMemberId={councilMemberId}
              councilId={council?.id}
              projectProposalId={projectProposalId}
              handleDownloadReviewFile={handleDownloadSpecializeReviewFile}
            />
            <ConfirmSubmit
              visible={isConfirmSubmitModalOpen}
              setVisible={setIsConfirmSubmitModalOpen}
              councilMemberId={councilMemberId}
              councilId={council.id}
              projectProposalId={projectProposalId}
              submitReview={submitSpecializeReview}
              refetch={specializeRefetch}
              refetchCouncil={refetchCouncil}
              setIsFormModalOpen={setIsFormModalOpen}
            />
          </>
        )}
      </div>
    </>
  );
}
